<template>
  <div class="enrolling-admission-publish">
    <span class="title">{{title}}</span>
    <span class="success-text">发布人数：{{publishNum}}</span>
    <span class="success-text">录取人数：{{admitNum}}</span>
    <span class="danger-text">不予录取人数：{{notAdmitNum}}</span>
  </div>
</template>

<script>
export default {
  name: 'EnrollAdmissionPublish',
  props: {
    title: String
  },
  data () {
    return {
      publishNum: 0,
      admitNum: 0,
      notAdmitNum: 0
    }
  },
  methods: {
    querySummaryInfo () {
      this.$ajax({
        url: '/workspace/manager/enrolling/admission/publish/querySummaryInfo',
        method: 'post',
        data: this.$qs.stringify({
          siteId: this.$attrs.extraValue,
          studentType: this.$attrs.studentType
        })
      }).then(response => {
        let data = response.data
        if (data) {
          switch (data['responseCode']) {
            case 'SUCCESS': {
              this.publishNum = data['publishNum'] || 0
              this.admitNum = data['admitNum'] || 0
              this.notAdmitNum = data['notAdmitNum'] || 0
              break
            }
            default: {
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      })
    }
  },
  mounted () {
    this.querySummaryInfo()
  },
  activated () {
    this.querySummaryInfo()
  }
}
</script>

<style lang="scss">
@import '../../../../../../../styles/color';
.enrolling-admission-publish {
  display: flex;
  align-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
  & > span {
    margin-right: 20px;
  }
  & > .success-text {
    color: $set-success-color;
  }
  & > .danger-text {
    color: $set-danger-color;
  }
}
</style>
